import { useTypesStore } from '../store/Types';
import { useTypesRender } from '../utils/useRender';
export var Url = props => {
  var {
    Url: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Url');
  return null;
};
Url.displayName = 'JVR.Url';